import { useEffect, useRef, useState, type ReactNode } from "react";

type Props = { heading: ReactNode; summary: ReactNode; distribution: ReactNode; trend: ReactNode; detail: boolean; scopeKey: string };
export function ProductionAnalysisLayout({ heading, summary, distribution, trend, detail, scopeKey }: Props) {
  const [desktop, setDesktop] = useState(false);
  useEffect(() => {
    const media = window.matchMedia("(min-width: 1000px) and (min-height: 650px)");
    const update = () => setDesktop(media.matches);
    update(); media.addEventListener("change", update);
    return () => media.removeEventListener("change", update);
  }, []);
  const scroll = useRef<HTMLDivElement>(null);
  const trendPanel = useRef<HTMLElement>(null);
  const [panel, setPanel] = useState<"distribution" | "trend">("distribution");
  useEffect(() => {
    if (!detail) { scroll.current?.scrollTo({ top: 0 }); setPanel("distribution"); }
  }, [detail, scopeKey]);
  const navigate = (next: "distribution" | "trend") => {
    setPanel(next);
    if (!window.matchMedia("(min-width: 1000px) and (min-height: 650px)").matches) {
      const target = next === "trend" ? trendPanel.current : scroll.current?.querySelector(".pa-presentation-distribution");
      target?.scrollIntoView({ block: "start", behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "instant" : "smooth" });
    }
  };
  useEffect(() => {
    const element = scroll.current;
    if (!element || detail) return;
    let lastSwitch = 0;
    const wheel = (event: WheelEvent) => {
      if (!window.matchMedia("(min-width: 1000px) and (min-height: 650px)").matches || event.ctrlKey || Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;
      if (event.target instanceof Element && event.target.closest("input, select, [role=dialog], .pa-date-options")) return;
      event.preventDefault();
      if (Math.abs(event.deltaY) < 15 || Date.now() - lastSwitch < 700) return;
      lastSwitch = Date.now();
      setPanel(event.deltaY > 0 ? "trend" : "distribution");
    };
    element.addEventListener("wheel", wheel, { passive: false });
    return () => element.removeEventListener("wheel", wheel);
  }, [detail]);
  return <div className="pa-presentation" data-detail={detail}>
    <div className="pa-presentation-heading">{heading}</div>
    <aside className="pa-presentation-summary" aria-label="Genel özet">{summary}</aside>
    <div className="pa-presentation-scroll" ref={scroll} tabIndex={detail ? undefined : 0} role={detail ? undefined : "region"} aria-label={detail ? undefined : "Dağılım ve günlük trend"} data-panel={panel} onKeyDown={event => {
      if (detail || event.target !== event.currentTarget) return;
      if (["ArrowDown", "PageDown", "End", "ArrowUp", "PageUp", "Home"].includes(event.key)) {
        event.preventDefault(); navigate(["ArrowDown", "PageDown", "End"].includes(event.key) ? "trend" : "distribution");
      }
    }}>
      <div className="pa-presentation-track">
      <section className="pa-presentation-panel pa-presentation-distribution" aria-label="Dağılım" inert={desktop && !detail && panel !== "distribution" ? true : undefined} aria-hidden={desktop && !detail && panel !== "distribution" ? true : undefined}>{distribution}</section>
      {!detail ? <section className="pa-presentation-panel pa-presentation-trend" aria-label="Günlük trend alanı" ref={trendPanel} inert={desktop && panel !== "trend" ? true : undefined} aria-hidden={desktop && panel !== "trend" ? true : undefined}>{trend}</section> : null}
      </div>
    </div>
  </div>;
}
